import React, { useState } from 'react';
import './CustomInput.css';

const CustomInput = ({ label, placeholder, icon: Icon, onChange }) => {
    const [value, setValue] = useState('');

    const handleChange = (e) => {
        setValue(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="input-field">
            <label className="input-label">{label}</label>
            <div className="input-container">
                <span className="input-icon">
                    <Icon />
                </span>
                <input
                    type="text"
                    className="input-text"
                    placeholder={placeholder}
                    value={value}
                    onChange={handleChange}
                />
            </div>
        </div>
    );
};

export default CustomInput;
